/* HOT DOGGY STUDIO · aparición al hacer scroll y parallax suave (respeta "reducir movimiento"; parallax solo en pantallas grandes). */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function reveal(root) {
    var els = (root || document).querySelectorAll('.sd-reveal:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }
  var items = [], ticking = false;
  function collect() { items = Array.prototype.slice.call(document.querySelectorAll('[data-sd-parallax]')); }
  function update() {
    ticking = false;
    var vh = window.innerHeight, big = window.innerWidth >= 990;
    items.forEach(function (el) {
      var img = el.querySelector('img'); if (!img) return;
      if (!big || reduce) { img.style.transform = ''; return; }
      var r = el.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var speed = parseFloat(el.getAttribute('data-sd-parallax')) || 0.12;
      var p = (r.top + r.height / 2 - vh / 2) / vh;
      img.style.transform = 'translate3d(0,' + (p * -100 * speed).toFixed(2) + '%,0) scale(1.18)';
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  function init(root) { reveal(root); collect(); update(); }
  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
})();
